import { useEffect, useRef, useState } from "react";
import PayLaterButton from "../../../../components/pages/sale/PaylaterBtn";
import CashButton from "../../../../components/pages/sale/cashbtn";
import SaleSettings from "../../SaleSettings";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import ReturnSale from "../../ReturnSale";
import uRLs from "../../../baseUtils";

import { capitalizeFirstLetter } from "./invoiceUtils";

import RemarkModal from "../../../../components/pages/sale/Remark";
import AxiosInstance from "../../../AxiosInstance";
import handleError from "../../../../constants/handleError";
import { useShowAlert } from "../../../../context/AlertContext";

const InvoiceInfoSidebar = ({
  globalData,
  isData,
  optData,
  isPurchase,
  returnTrack,
  handleSelectedSale,
  handlelatestSale,
  closeAuto,
  setCloseAuto,
  latestVersion,
  setData,
  handleSelectedReturnSale,
  isPreSale
}) => {
  const [showFullRemark, setShowFullRemark] = useState(false);
  const paylaterRef = useRef();
  const cashRef = useRef();
  const paymentData = isData?.paymentInfo?.refundPaymentMethods;

  const [remark, setRemark] = useState("");
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const showAlert = useShowAlert();
  const handleUpdateRemark = async (value) => {
    try {
      let data;
      if (isPreSale) {
        const response = await AxiosInstance.patch(
          `module/presale/remarks/${globalData?.preSaleData?._id}`,
          {
            remarks: value,
          }
        );

        data = response.data;

        setRemark(data?.results?.remarks || value);

        setData((prev) => ({
          ...prev,
          preSaleData: {
            ...prev.preSaleData,
            remarks: data?.results?.remarks || value,
          },
        }));
      } else {
        const response = await AxiosInstance.put(
          `module/sale/remark/${returnTrack ? globalData?._id : isData?._id}`,
          {
            remark: value,
          }
        );

        data = response.data;

        setRemark(data?.results?.remark || value);

        setData((prev) => ({
          ...prev,
          remark: data?.results?.remark || value,
        }));
      }

      setRemarkModalOpen(false);
    } catch (err) {
      handleError(err, showAlert);
      console.error(err);
    }
  };
  
  const remarkText = remark;
  useEffect(() => {
    setRemark(globalData?.remark ?? globalData?.remarks ?? globalData?.preSaleData?.remarks ?? "");
  }, [globalData?.remark, globalData?.remarks,globalData?.preSaleData?.remarks]);
  const isReturnRemark = !!globalData?.remarks;
  const isReturnSale = !!returnTrack;
  const showRemarkSection = !isReturnSale || isReturnRemark;

  return (
    <div
      className="border-start bg-white"
      style={{
        width: "300px",
        flex: "0 0 300px",
        overflowY: "auto",
        padding: "8px",
      }}
    >
      {/* REMARK SECTION */}
      {showRemarkSection && (
        <div
          className="mb-2"
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <div
            className="d-flex align-items-center mb-1"
            style={{
              color: "#16a34a",
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            <i className="bx bx-notepad me-1 font-16"></i>
            Remark
            {!isReturnRemark && !isPurchase&&  (
              <div className="ms-auto">
                <button
                  type="button"
                  className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                  onClick={() => {
                    setRemark(remarkText || "");
                    setRemarkModalOpen(true);
                  }}
                >
                  <i className="ng ng-ng-edit-icon"></i>
                </button>
              </div>
            )}
          </div>
          <div
            style={{
              color: "#4b5563",
              fontSize: "12px",
              lineHeight: "1.6",
              wordBreak: "break-word",
              ...(showFullRemark
                ? {}
                : {
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }),
            }}
          >
            {" "}
            {capitalizeFirstLetter(remarkText)}{" "}
          </div>{" "}
          {remarkText?.length > 120 && (
            <span
              onClick={() => setShowFullRemark(!showFullRemark)}
              style={{
                color: "#2563eb",
                fontSize: "12px",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              {" "}
              {showFullRemark ? "Show Less" : "...more"}{" "}
            </span>
          )}{" "}
        </div>
      )}
      {!isPurchase && !isPreSale && (
      returnTrack ? (
        <>
          <div
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            {/* HEADER */}
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                padding: "8px 12px",
                borderBottom: "1px solid #f1f5f9",
                background: "#f9fafb",
              }}
            >
              <div
                className="fw-600"
                style={{
                  fontSize: "13px",
                  color: "#111827",
                }}
              >
                {returnTrack ? "Refund Details" : "Payment Details"}
              </div>
            </div>

            {/* PAYMENT LIST */}
            <div>
              {/* CASH */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                  cursor: paymentData?.CASH > 0 ? "pointer" : "default",
                }}
                // onClick={(e) => {
                //   if (paymentData?.CASH > 0) {
                //     cashRef.current.openPopover(e);
                //   }
                // }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  {/* <i className="bx bx-money font-18 text-success"></i> */}
                  {/* {paymentData?.CASH > 0 && (
                      <i className="bx bx-show text-success  font-16"></i>
                    )} */}
                  <span className="font-13">Cash</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="fw-600 font-13">
                    ₹
                    {CurrencyConverter.toCurrency(
                      paymentData?.CASH || 0,
                      "INR",
                    )}
                  </span>
                </div>
              </div>

              {/* CARD */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">Card</span>
                </div>

                <span className="fw-600 font-13">
                  ₹{CurrencyConverter.toCurrency(paymentData?.CARD || 0, "INR")}
                </span>
              </div>

              {/* ONLINE */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">Online</span>
                </div>

                <span className="fw-600 font-13">
                  ₹
                  {CurrencyConverter.toCurrency(
                    paymentData?.ONLINE || 0,
                    "INR",
                  )}
                </span>
              </div>

              {/* UPI */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">UPI</span>
                </div>

                <span className="fw-600 font-13">
                  {" "}
                  ₹{CurrencyConverter.toCurrency(paymentData?.UPI || 0, "INR")}
                </span>
              </div>

              {/* PAYLATER */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  cursor: globalData.paylateramount > 0 ? "pointer" : "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
                // onClick={(e) => {
                //   if (paymentData?.PAYLATER > 0) {
                //     paylaterRef.current.openPopover(e);
                //   }
                // }}
              >
                <div className="d-flex align-items-center gap-2">
                  {/* <i className="bx bx-time font-18 text-danger"></i> */}
                  {/* {paymentData?.PAYLATER > 0 && (
                      <i className="bx bx-show text-danger font-16"></i>
                    )} */}
                  <span className="font-13">PayLater</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="fw-600 font-13 text-danger">
                    ₹
                    {CurrencyConverter.toCurrency(
                      paymentData?.PAYLATER || 0,
                      "INR",
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                padding: "8px 12px",
                borderBottom: "1px solid #f1f5f9",
                background: "#f9fafb",
              }}
            >
              <div
                className="fw-600"
                style={{
                  fontSize: "13px",
                  color: "#111827",
                }}
              >
                {returnTrack ? "Refund Details" : "Payment Details"}
              </div>
            </div>

            {/* PAYMENT LIST */}
            <div>
              {/* CASH */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                  cursor: globalData.cashamount > 0 ? "pointer" : "default",
                }}
                onClick={(e) => {
                  if (globalData.cashamount > 0) {
                    cashRef.current.openPopover(e);
                  }
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  {/* <i className="bx bx-money font-18 text-success"></i> */}
                  {globalData.cashamount > 0 && (
                    <i className="bx bx-show text-success  font-16"></i>
                  )}
                  <span className="font-13">Cash</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="fw-600 font-13">
                    ₹{globalData?.cashPaid || 0}
                  </span>
                </div>
              </div>

              {/* CARD */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">Card</span>
                </div>

                <span className="fw-600 font-13">
                  ₹{globalData?.cardPaid || 0}
                </span>
              </div>

              {/* ONLINE */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">Online</span>
                </div>

                <span className="fw-600 font-13">
                  ₹{globalData?.onlinePaid || 0}
                </span>
              </div>

              {/* UPI */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span className="font-13">UPI</span>
                </div>

                <span className="fw-600 font-13">
                  ₹{globalData?.upiPaid || 0}
                </span>
              </div>

              {/* PAYLATER */}
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  padding: "4px 8px",
                  cursor: globalData.paylateramount > 0 ? "pointer" : "default",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#fff";
                }}
                onClick={(e) => {
                  if (globalData.paylateramount > 0) {
                    paylaterRef.current.openPopover(e);
                  }
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  {/* <i className="bx bx-time font-18 text-danger"></i> */}
                  {globalData.paylateramount > 0 && (
                    <i className="bx bx-show text-danger font-16"></i>
                  )}
                  <span className="font-13">PayLater</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <span className="fw-600 font-13 text-danger">
                    ₹{globalData?.balanceDue || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      )

    )}
      <RemarkModal
        open={remarkModalOpen}
        initialValue={remark}
        onClose={() => setRemarkModalOpen(false)}
        onSave={handleUpdateRemark}
      />

      {!returnTrack && !isPurchase && !isPreSale && (
        <SaleSettings
          isData={isData}
          DateConverter={DateConverter}
          CurrencyConverter={CurrencyConverter}
          handleSelectedSale={handleSelectedSale}
          version={globalData?.saleVersion}
          handlelatestSale={handlelatestSale}
          closeAuto={closeAuto}
          setCloseAuto={setCloseAuto}
          latestVersion={latestVersion}
        />
      )}
      {uRLs.RETURN_SALE === "true" && !isPurchase &&  !isPreSale &&(
        <ReturnSale
          saleID={returnTrack ? globalData?.saleId : isData?._id}
          saleReturnNo={globalData?.saleReturnNo}
          handleSelectedReturnSale={handleSelectedReturnSale}
          version={globalData?.saleVersion}
          handlelatestSale={handlelatestSale}
          closeAuto={closeAuto}
          setCloseAuto={setCloseAuto}
          latestVersion={latestVersion}
        />
      )}
      <CashButton
        ref={cashRef}
        trackId={
          returnTrack
            ? paymentData?.boxCashInfo?.trackid
            : globalData?.boxCashInfo?.trackid
        }
        trackMode={
          returnTrack
            ? paymentData?.boxCashInfo?.trackmode
            : globalData?.boxCashInfo?.trackmode
        }
      />

      <PayLaterButton
        ref={paylaterRef}
        customerId={globalData?.paylaterInfo?.customerid}
        trackMode={globalData?.paylaterInfo?.trackmode}
      />
    </div>
  );
};

export default InvoiceInfoSidebar;

